import type { MouseEvent as ReactMouseEvent } from "react";

export type RevealRoute =
  | "/marketplace"
  | "/opportunities"
  | "/persona-opportunities";

type RevealSearchValue = boolean | number | string | null | undefined;

export interface RevealNavigationTarget {
  route: RevealRoute;
  targetId: string;
  expandPath?: readonly string[];
  search: Readonly<Record<string, RevealSearchValue>>;
}

interface NavigateAndRevealOptions extends RevealNavigationTarget {
  event?: ReactMouseEvent<HTMLElement>;
  closePanel?: () => Promise<void> | void;
  navigate: () => Promise<void> | void;
}

export function getRevealHref({
  route,
  targetId,
  search,
}: RevealNavigationTarget): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(search)) {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  }

  if (![...params.values()].includes(targetId)) {
    throw new Error("Reveal target must be represented in the route search");
  }

  return `${route}?${params.toString()}`;
}

export async function navigateAndReveal({
  event,
  closePanel,
  navigate,
}: NavigateAndRevealOptions): Promise<boolean> {
  if (
    event &&
    (event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0)
  ) {
    return false;
  }

  event?.preventDefault();
  await closePanel?.();
  await navigate();
  return true;
}
